// extracted by mini-css-extract-plugin
export default {"container":"components-CardWrapper-_CardWrapper-module_container"};